<template>
    <Drag
        class="file-boundary"
        :node="node"
        :style="iconStyle"
        :transfer-data="node"
        @dragstart="dragActive(node)"
        @dragend="settle($el)"
        @dblclick.stop.native="openFile(node.path)"
    >

    <!-- openWindow('FileSystem') -->

        <!-- FILE -->
        <div class="file">
            <i class="file-icon" :class="node.icon"></i>
            <span class="file-label" v-text="node.name"></span>
        </div>

    </Drag>
</template>

<script>
    import { mapActions } from 'vuex';
    import { Drag } from 'vue-drag-drop';
    import fileMixin from '../mixins.js';

    export default {
        components: {
            Drag: Drag,
        },
        mixins: [
            fileMixin
        ],
        props: {
            node: [Object, Array, String, Boolean, Number], // change back to object
            coords: Array,
            index: [Number, String]//change this back to number
        },
        data() {
            return {
                dropTimeout: null
            }
        },
        computed: {
            gridId(){
                return this.node.gridId;
            },

            iconStyle() {
                let x = 0,
                    y = 0;
                // if none are set - loop through and find an empty space
                if (this.coords && this.gridId) {
                    x = this.coords[this.gridId].x;
                    y = this.coords[this.gridId].y;
                    // console.log('x: '+ x + ' y: '+y + ' <-- icon');
                }
                else if (this.coords) {
                    x = this.coords[this.index].x;
                    y = this.coords[this.index].y;
                }

                return {
                    // 'transform': 'translate3d('+ x +'px, '+ y +'px, 0px)'
                    'left': x + 'px',
                    'top': y + 'px',
                }
            }

        },
        methods: {
            ...mapActions('gameOS', [
                // 'deselectIcons',
                'openWindow',
                'openFile'
            ]),
            dragActive(node) {
                this.$emit('drag-active', node);
            },

            settle(target) {
                target.classList.add("has-dropped");

                clearTimeout(this.dropTimeout);

                this.dropTimeout = setTimeout(() => {
                    target.classList.remove("has-dropped");
                }, 500)
            }
        }
    }
</script>

<style lang="scss" scoped>

    //-----------------------------------------------------------------
    // SETTLE TRANSITION
    //-----------------------------------------------------------------

    [draggable=true] {
      -khtml-user-drag: element;
    }

    .file-boundary.has-dropped  {
        animation: settle-drop 500ms ease 0s alternate 1 forwards;
        transition: transform 300ms ease-out;
    }

    @keyframes settle-drop {
        from {
            transform: scale(1.1); //translateY(10px);
        } to {
            transform: scale(1.0); //translateY(0);
        }
    }

    //--------------------------------------------------------------------
    // FILE BOUNDARY
    //--------------------------------------------------------------------

    .file-boundary {
        display: flex;
        align-items: flex-start;
        justify-content: center;
        position: absolute; // [LOCKED] - (previously relative) so important - allows drag
        width: rem-calc(100);
        height: rem-calc(80); // [LOCKED] - TODO: replace with a string filter EG. textext...jpg
        border: 1px solid black; // comment out
        line-height: 1; // [LOCKED] - remove gap
        text-align: center;
        // background: #ddd;
        overflow: hidden; // [LOCKED]
        pointer-events: none;
        will-change: transform;
    }

    .file-icon,
    .file-label {
        pointer-events: auto;
        background: rgba(pink, 0.4);
    }

    .file-icon {
        padding-bottom: rem-calc(5);
        // border: 1px solid black;
        font-size: rem-calc(38);
    }

    .file-label {
        display: block;
        max-width: rem-calc(85); // [LOCKED]
        padding: 0 4px; // [LOCKED]
        font-size: rem-calc(13); // [LOCKED]
        font-weight: 500; // TODO: setup weights
        text-shadow: 0 1px 5px black; // [LOCKED]
        color: white; // [LOCKED]
        line-height: 1.4; // [LOCKED]
        // white-space: nowrap; [REFERENCE]
        overflow: hidden; // [LOCKED] - ellipsis
        text-overflow: ellipsis; // [LOCKED] - ellipsis
    }

    .file-boundary.active .file-label,
    .file-boundary.selected .file-label {
        background: darken(#364847, 0%); // where does this var come from?
        text-shadow: none; // [LOCKED]
    }

    .file-boundary.active .file-icon,
    .file-boundary.selected .file-icon {
        color: darken(#364847, 0%);
    }

    // override to show selected but clicked away from
    .file-boundary.inactive .file-label {
        background-color: rgba(black, 0.15);
        text-shadow: none;
    }

</style>